module.exports = __webpack_public_path__ + "static/media/chat-private-bubble.503e93b0.svg";